module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargador-dd-39680df0.png";